var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossroad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H12C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8H5.41421L4.41421 9L5.41421 10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H5C4.73478 12 4.48043 11.8946 4.29289 11.7071L2.29289 9.70711C1.90237 9.31658 1.90237 8.68342 2.29289 8.29289L4.29289 6.29289Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C11 2.44772 11.4477 2 12 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289L21.7071 4.29289C22.0976 4.68342 22.0976 5.31658 21.7071 5.70711L19.7071 7.70711C19.5196 7.89464 19.2652 8 19 8H12C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6H18.5858L19.5858 5L18.5858 4H12C11.4477 4 11 3.55228 11 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C11 10.4477 11.4477 10 12 10H19C19.2652 10 19.5196 10.1054 19.7071 10.2929L21.7071 12.2929C22.0976 12.6834 22.0976 13.3166 21.7071 13.7071L19.7071 15.7071C19.5196 15.8946 19.2652 16 19 16H12C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14H18.5858L19.5858 13L18.5858 12H12C11.4477 12 11 11.5523 11 11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 23C8 22.4477 8.44772 22 9 22H15C15.5523 22 16 22.4477 16 23C16 23.5523 15.5523 24 15 24H9C8.44772 24 8 23.5523 8 23Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.5523 0 13 0.447715 13 1V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V1C11 0.447715 11.4477 0 12 0Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossroad);
export default __webpack_public_path__ + "static/media/crossroad.46f0407cb763004c34f2c84e2de0ad8b.svg";
export { ForwardRef as ReactComponent };